import axios from "axios";
import { API_BASE_URL } from "../../../config";
import {
  normalizePaymentFlow,
  normalizePaymentFlowWindow,
  paymentFlowNeedsFallback,
} from "../treasuryHelpers";

function authHeaders() {
  const token = localStorage.getItem("adminToken");
  return { Authorization: `Bearer ${token}` };
}

async function fetchDeskCashStats(desk) {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/transactions?desk=${desk}&status=Success&currency=CASH&limit=1&refresh=1`,
    { headers: authHeaders() }
  );

  const summary = data?.summary;
  const total = desk === "deposits"
    ? Number(summary?.amount?.depositTotal) || 0
    : Number(summary?.amount?.withdrawalTotal) || 0;

  return {
    total,
    count: Number(summary?.total) || 0,
  };
}

async function fetchPaymentFlowFallback() {
  const [deposits, withdrawals] = await Promise.all([
    fetchDeskCashStats("deposits"),
    fetchDeskCashStats("withdrawals"),
  ]);

  const allTime = normalizePaymentFlowWindow({
    deposits,
    withdrawals,
    net: deposits.total - withdrawals.total,
  });

  return {
    allTime,
    last24h: normalizePaymentFlowWindow(),
    last7d: normalizePaymentFlowWindow(),
  };
}

async function resolvePaymentFlow(raw) {
  if (!paymentFlowNeedsFallback(raw)) {
    return normalizePaymentFlow(raw);
  }

  try {
    return await fetchPaymentFlowFallback();
  } catch {
    return normalizePaymentFlow(raw);
  }
}

export async function fetchAdminTreasuryOverview() {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/treasury/overview`,
    { headers: authHeaders() }
  );

  const paymentFlow = await resolvePaymentFlow(data?.paymentFlow);
  return { ...data, paymentFlow };
}

export async function refreshAdminProviderBalance() {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/website/admin/treasury/provider-balance/refresh`,
    {},
    { headers: authHeaders() }
  );

  const paymentFlow = await resolvePaymentFlow(data?.paymentFlow);
  return {
    ...data,
    paymentFlow,
  };
}

export async function fetchAdminProviderBalanceHistory({ page = 1, limit = 20 } = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/treasury/provider-balance/history?${params.toString()}`,
    { headers: authHeaders() }
  );
  return data;
}
